import {Space, Steps} from "antd";
import {useCreateSessionContext} from "../context/create-session";
import type {CreateSessionSteps} from "../reducers/create-session/types";

export function CreateSessionFormSteps() {
  const {state} = useCreateSessionContext();
  const mapStepToNumber: Record<CreateSessionSteps, number> = {
    basicForm: 0,
    checkoutForm: 1,
    coverImagesUpload: 2,
    automations: 3,
  };

  return (
    <div>
      <Steps
        current={mapStepToNumber[state.currentCreateSessionStep]}
        size="small"
        direction="vertical"
      >
        <Steps.Step title="Session information" />
        <Steps.Step
          title="Checkout form"
          disabled={state.currentCreateSessionStep === "basicForm"}
        />
        <Steps.Step
          title="Cover image upload"
          disabled={
            state.currentCreateSessionStep === "basicForm" ||
            state.currentCreateSessionStep === "checkoutForm"
          }
        />
        <Steps.Step
          title="Automations"
          disabled={
            state.currentCreateSessionStep === "basicForm" ||
            state.currentCreateSessionStep === "checkoutForm" ||
            state.currentCreateSessionStep === "coverImagesUpload"
          }
        />
      </Steps>
    </div>
  );
}

export function CreateSessionFormStepsMobile() {
  const {state} = useCreateSessionContext();
  const mapStepToNumber: Record<CreateSessionSteps, number> = {
    basicForm: 0,
    checkoutForm: 1,
    coverImagesUpload: 2,
    automations: 3,
  };
  const mapStepToTitle: Record<CreateSessionSteps, string> = {
    basicForm: "Session information",
    checkoutForm: "Checkout form",
    coverImagesUpload: "Cover image upload",
    automations: "Automations",
  };
  return (
    <Space size={16} align="center">
      <div
        style={{
          width: "2.4rem",
          height: "2.4rem",
          borderRadius: "3.2rem",
          backgroundColor: "#222222",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mapStepToNumber[state.currentCreateSessionStep] + 1}
      </div>

      <p>{mapStepToTitle[state.currentCreateSessionStep]}</p>
    </Space>
  );
}
